module.exports = __webpack_public_path__ + "static/images/event/History_clock_time_clear_url.png";